var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_cof.js
// module id = 57
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20